import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách năng lực theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách năng lực đã sắp xếp theo sortOrder
 */
export const getIntroduceCapacitiesByLanguage = async (languageCode) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.INTRODUCE_CAPACITIES.GET_BY_LANGUAGE(languageCode)
    );
    const data = response.data;

    if (data && data.success && Array.isArray(data.data)) {
        return data.data;
    }

    return [];
};
